import { Component, TemplateRef, contentChild, input, model } from '@angular/core';

@Component({
  selector: 'app-primeng-drawer',
  template: `
    <p-drawer 
      [visible]="visible()" 
      (visibleChange)="onVisibleChange($event)"
      [position]="position()"
      [showCloseIcon]="showCloseIcon()"
      [modal]="modal()"
      [ngClass]="customClass()">

      <ng-template #drawerHdr pTemplate="header" *ngIf="drawerHeader()">
        <ng-container *ngTemplateOutlet="drawerHeader()!"></ng-container>
      </ng-template>

      <ng-container *ngIf="drawerContent()">
        <ng-container *ngTemplateOutlet="drawerContent()!"></ng-container>
      </ng-container>

      <ng-template #drawerFtr pTemplate="footer" *ngIf="drawerFooter()">
        <ng-container *ngTemplateOutlet="drawerFooter()!"></ng-container>
      </ng-template>

    </p-drawer>
  `,
  styles: [],
  standalone: false,
})
export class PrimengDrawerComponent {
  visible = model<boolean>(false);
  position = input<'left' | 'right' | 'top' | 'bottom' | 'full'>('left');
  header = input<string>('');
  showCloseIcon = input<boolean>(true);
  modal = input<boolean>(true);
  customClass = input<string>('');

  drawerHeader = contentChild<TemplateRef<any>>('drawerHeader');
  drawerContent = contentChild<TemplateRef<any>>('drawerContent');
  drawerFooter = contentChild<TemplateRef<any>>('drawerFooter');

  onVisibleChange(val: boolean) {
    this.visible.set(val);
  }
}
